import { v4 as uuidv4 } from 'uuid'
import * as common from 'store/modules/common'
import { api } from './api'
import { localize } from 'store/modules/localization'
import { format } from 'utils/stringUtilities'

export const prefix = 'dropzone'
const MAX_FILESIZE = 10 * 1024 * 1024

export { api }
export const initialState = {
  uploading: false,
  progress: 0
}
export const actionTypes = {
  uploading: `${prefix}/uploading`,
  updateProgress: `${prefix}/updateProgress`
}
export const actionCreators = {
  uploadFile: (files = [], callback) => (dispatch, getState) => {
    if (files.length > 0 && getState().dropzone.uploading === false) {
      if (files[0].size > MAX_FILESIZE) {
        const formatString = localize(getState().localization, 'dropzone.maxFileSizeExceeded')
        const message = format(formatString, MAX_FILESIZE, files[0].size)
        common.showErrorAlert({ dispatch, getState, message })
        return
      } 
      dispatch({ type: actionTypes.uploading, payload: true })
      setTimeout(() => {

        const data = new FormData()
        data.append('file', files[0])
        const fileId = uuidv4()
        api.upload(fileId, data, (e) => dispatch(actionCreators.updateProgress(Math.round((e.loaded * 100) / e.total))))
          .then(() => {
            dispatch({ type: actionTypes.uploading, payload: false })
            dispatch(actionCreators.updateProgress(0))
            if (typeof callback === 'function') { callback(fileId) }
          })
          .catch(error => common.handleError(prefix, { getState, dispatch, error, update: { uploading: false } }))
      }, 0)
    }
  },
  updateProgress: (progress) => ({
    type: actionTypes.updateProgress,
    payload: progress
  }),
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.uploading: return { ...state, uploading: action.payload }
    case actionTypes.updateProgress: return { ...state, progress: action.payload }
    default: return common.reducer(state, action, prefix)
  }
}
